import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const AccordionModuleAnimation = () => {
  const containers = document.querySelectorAll(".accordion-module");
  if (containers.length < 1) {
    return;
  }

  const reduceMotion = window.matchMedia(
    "(prefers-reduced-motion: reduce)",
  ).matches;
  if (reduceMotion) return;

  const base = {
    y: 0,
    opacity: 1,
    duration: 0.75,
    ease: "power2.inOut",
  };
  const applyAnimations = () => {
    containers.forEach((container) => {
      const headline = container.querySelectorAll(
        ".accordion-module__headline",
      );
      const subline = container.querySelectorAll(".accordion-module__subline");
      const text = container.querySelectorAll(".accordion-module__text");
      const button = container.querySelectorAll(".accordion-module__button");
      const accordionTabs = container.querySelectorAll(
        ".accordion-module__tab",
      );

      if (
        !headline.length &&
        !subline.length &&
        !text.length &&
        !button.length &&
        !accordionTabs.length
      )
        return;

      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: container,
          start: "top 80%",
          once: true,
          fastScrollEnd: true,
        },
      });

      if (headline.length) {
        tl.to(headline, base, 0);
      }

      if (subline.length) {
        tl.to(subline, base, 0.2);
      }

      if (text.length) {
        tl.to(text, base, 0.2);
      }

      if (button.length) {
        tl.to(
          button,
          {
            y: 0,
            opacity: 1,
            duration: 0.75,
            ease: "back.out(1.7, 0.5)",
          },
          0.6,
        );
      }

      if (accordionTabs.length) {
        const tl2 = gsap.timeline({
          scrollTrigger: {
            trigger: accordionTabs[0],
            start: "top 80%",
            once: true,
            fastScrollEnd: true,
          },
        });

        tl2.to(
          accordionTabs,
          {
            y: 0,
            opacity: 1,
            duration: 0.75,
            ease: "power2.inOut",
            stagger: 0.15,
          },
          "tl+=0",
        );
      }
    });
  };
  applyAnimations();
};

export default AccordionModuleAnimation;
